import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  title: "light mode",
  class: "bi bi-sun-fill"
}
const _hoisted_2 = {
  key: 1,
  title: "dark mode",
  class: "bi bi-moon-stars-fill"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleTheme && _ctx.toggleTheme(...args))),
    class: "menu-button"
  }, [
    (_ctx.isDarkMode)
      ? (_openBlock(), _createElementBlock("i", _hoisted_1))
      : (_openBlock(), _createElementBlock("i", _hoisted_2))
  ]))
}